<script setup lang="ts">
type Props = {
  status: boolean;
  disabled?: boolean;
};

const { status = false, disabled = false } = defineProps<Props>();
</script>

<template>
  <div :class="$style.inputToggle">
    <label :class="$style.container">
      <span
        :class="[
          $style.switch,
          { [$style.checked]: status },
          { [$style.disabled]: disabled },
        ]"
      ></span>
    </label>
  </div>
</template>

<style module lang="scss">
.inputToggle {
  @apply flex items-center relative z-10;

  --switch-container-width: 36px;
  width: var(--switch-container-width);

  .container {
    @apply cursor-pointer flex items-center;

    .switch {
      @apply flex items-center relative bg-texts/15 border-texts/10 border border-solid flex-shrink-0 shadow-md shadow-black/5;

      --switch-size: calc(var(--switch-container-width) / 1.8);
      height: var(--switch-size);
      flex-basis: var(--switch-container-width);
      border-radius: var(--switch-size);
      transition: background-color 180ms ease-in-out;

      &::before {
        @apply content-[''] absolute left-0 rounded-full bg-texts/50 z-10 shadow-md shadow-black/30;

        height: calc(var(--switch-size) - 1px);
        width: calc(var(--switch-size) - 1px);
        transition: transform 250ms ease-in-out;
      }

      &.checked {
        @apply bg-primary;

        &::before {
          @apply bg-white/90;
          transform: translateX(
            calc(var(--switch-container-width) - var(--switch-size))
          );
        }
      }

      &.disabled {
        @apply opacity-40 cursor-not-allowed;
      }
    }
  }
}
</style>
